(function () {
  var reduce = window.matchMedia('(prefers-reduced-motion: reduce)').matches;

  function lei(c) { return (c / 100).toFixed(2).replace('.', ',') + ' lei'; }
  function plain(c) { return (c / 100).toFixed(2).replace('.', ','); }

  function init(root) {
    var q = function (r) { return root.querySelector('[data-r="' + r + '"]'); };
    var qa = function (r) { return [].slice.call(root.querySelectorAll('[data-r="' + r + '"]')); };

    var dataEl = q('variants');
    var variants = dataEl ? JSON.parse(dataEl.textContent) : [];
    var metru = root.getAttribute('data-metru') === 'true';

    var form = q('form'), vid = q('vid'), qty = q('qty'), minus = q('minus'), plus = q('plus');
    var price = q('price'), was = q('was'), optout = q('optout'), total = q('total'), calc = q('calc');
    var dimL = q('dimL'), dimW = q('dimW'), dimX = q('dimX'), dimWv = q('dimWv'), dimA = q('dimA'), dimAr = q('dimAr');
    var stock = q('stock'), stocktxt = q('stocktxt'), assure = q('assure');
    var stage = q('stage'), add = q('add'), addlbl = q('addlbl'), err = q('err'), errtxt = q('errtxt');
    var select = q('select'), skus = qa('sku');
    var opts = qa('opt'), thumbs = qa('thumb');

    var MIN = Math.max(1, parseInt(qty.getAttribute('min'), 10) || 1), MAX = parseInt(qty.getAttribute('max'), 10) || 999;
    var current = variants.filter(function (v) { return String(v.id) === vid.value; })[0] || variants[0];
    var raf = null;

    function n() { var x = parseInt(qty.value, 10); return isNaN(x) ? MIN : x; }

    function animate(from, to) {
      if (raf) { cancelAnimationFrame(raf); raf = null; }
      if (reduce || from === to) { total.textContent = lei(to); return; }
      var t0 = performance.now();
      (function tick(now) {
        var p = Math.min(1, (now - t0) / 340), e = 1 - Math.pow(1 - p, 3);
        total.textContent = lei(Math.round(from + (to - from) * e));
        if (p < 1) raf = requestAnimationFrame(tick);
      })(t0);
    }

    function widthCm(v) {
      var m = /(\d+(?:[.,]\d+)?)\s*cm/i.exec(v.title || '');
      return m ? parseFloat(m[1].replace(',', '.')) : null;
    }

    function setDim(el, val) {
      if (el.getAttribute('data-v') === val) return;
      var first = !el.hasAttribute('data-v');
      el.setAttribute('data-v', val);
      el.innerHTML = val + '<small>m</small>';
      if (!reduce && !first) { el.classList.remove('bump'); void el.offsetWidth; el.classList.add('bump'); }
    }

    function drawPiece(count) {
      if (!dimL) return;
      var w = widthCm(current), has = w !== null;
      setDim(dimL, String(count));
      dimX.hidden = !has; dimWv.hidden = !has; dimAr.hidden = !has;
      if (has) {
        setDim(dimW, (w / 100).toFixed(2).replace('.', ','));
        dimA.textContent = (count * w / 100).toFixed(2).replace('.', ',') + ' m²';
      }
    }

    function minMsg() {
      if (MIN === 1) return metru ? 'Introdu cel puțin 1 metru liniar.' : 'Cantitatea minimă este 1.';
      return 'Comanda minimă este ' + MIN + (metru ? ' metri liniari.' : ' bucăți.');
    }

    function setErr(msg) {
      if (!err) return;
      if (msg) { errtxt.textContent = msg; err.setAttribute('data-on', ''); }
      else { err.removeAttribute('data-on'); }
    }

    function render(prevTotal) {
      var count = n(), t = current.price * count;
      if (calc) calc.textContent = count + ' × ' + plain(current.price);
      drawPiece(count);
      animate(prevTotal === undefined ? t : prevTotal, t);
      minus.disabled = count <= MIN;
      plus.disabled = count >= MAX;
    }

    function apply(v) {
      var prev = current ? current.price * n() : undefined;
      current = v;
      vid.value = v.id;
      price.textContent = v.pricef;
      if (was) {
        if (v.compare > v.price) { was.textContent = v.comparef; was.hidden = false; }
        else { was.hidden = true; }
      }
      if (optout) optout.textContent = v.title;
      skus.forEach(function (s) { s.textContent = v.sku; });
      if (v.img && stage) {
        stage.src = v.img;
        stage.removeAttribute('srcset');
      }
      stock.setAttribute('data-state', v.available ? 'in' : 'out');
      stocktxt.textContent = v.available ? 'În stoc, expediere imediată' : 'Momentan indisponibil';
      if (assure) assure.textContent = v.available ? 'Stoc permanent, expediere imediată' : 'Scrie-ne pentru disponibilitate';
      add.disabled = !v.available;
      addlbl.textContent = v.available ? 'Adaugă în coș' : 'Indisponibil';
      opts.forEach(function (o) {
        var on = o.getAttribute('data-vid') === String(v.id);
        o.setAttribute('aria-checked', on ? 'true' : 'false');
        o.setAttribute('tabindex', on ? '0' : '-1');
      });
      if (select) select.value = String(v.id);
      if (window.history && history.replaceState) {
        var url = new URL(window.location.href);
        url.searchParams.set('variant', v.id);
        history.replaceState(null, '', url.toString());
      }
      render(prev);
    }

    function byId(id) { return variants.filter(function (v) { return String(v.id) === String(id); })[0]; }

    opts.forEach(function (o, i) {
      o.addEventListener('click', function () { apply(byId(o.getAttribute('data-vid'))); });
      o.addEventListener('keydown', function (e) {
        var t = null;
        if (e.key === 'ArrowRight' || e.key === 'ArrowDown') t = opts[(i + 1) % opts.length];
        if (e.key === 'ArrowLeft' || e.key === 'ArrowUp') t = opts[(i - 1 + opts.length) % opts.length];
        if (t) { e.preventDefault(); t.focus(); apply(byId(t.getAttribute('data-vid'))); }
      });
    });
    if (select) select.addEventListener('change', function () { apply(byId(select.value)); });

    minus.addEventListener('click', function () {
      var p = current.price * n(); qty.value = Math.max(MIN, n() - 1); setErr(''); render(p);
    });
    plus.addEventListener('click', function () {
      var p = current.price * n(); qty.value = Math.min(MAX, n() + 1); setErr(''); render(p);
    });
    qty.addEventListener('input', function () {
      var raw = qty.value.trim(), x = parseInt(raw, 10);
      if (raw === '') { setErr(''); return; }
      if (isNaN(x) || x < 1) { setErr(minMsg()); qty.value = MIN; }
      else if (x < MIN) { setErr(minMsg()); }
      else if (x > MAX) { setErr(metru ? 'Pentru comenzi peste ' + MAX + ' m, scrie-ne — îți pregătim rola.' : 'Pentru cantități peste ' + MAX + ', scrie-ne.'); qty.value = MAX; }
      else setErr('');
      render();
    });
    qty.addEventListener('blur', function () {
      if (qty.value.trim() === '') { qty.value = MIN; setErr(''); render(); }
      else if (n() < MIN) { qty.value = MIN; setErr(minMsg()); render(); }
    });

    thumbs.forEach(function (t) {
      t.addEventListener('click', function () {
        stage.src = t.getAttribute('data-src');
        stage.removeAttribute('srcset');
        thumbs.forEach(function (x) { x.setAttribute('aria-current', x === t ? 'true' : 'false'); });
      });
    });

    form.addEventListener('submit', function (e) {
      if (n() < MIN) {
        e.preventDefault();
        qty.value = MIN; setErr(minMsg()); render(); qty.focus();
        return;
      }
      add.setAttribute('data-state', 'loading');
      addlbl.textContent = 'Se adaugă…';
    });

    window.addEventListener('pageshow', function () {
      add.removeAttribute('data-state');
      addlbl.textContent = current.available ? 'Adaugă în coș' : 'Indisponibil';
    });

    render();
  }

  document.querySelectorAll('[data-product-root]').forEach(init);
})();
